<div class="main-content-container">
  <kendo-stacklayout orientation="vertical" [gap]="20">
    <ng-content select="[notifications]">
      <!-- Additional notifications from subcomponent, use as:
          <ng-container notifications> <content /> </ng-container> -->
    </ng-content>
    <div class="banner">
      <div>
        @if ($isLoading()) {
          <kendo-skeleton class="skeleton banner-text header-text" width="50%" [animation]="animation" />
          <kendo-skeleton class="skeleton banner-text subheader-text" width="50%" [animation]="animation" />
          <kendo-skeleton class="skeleton banner-text subheader-text" width="50%" [animation]="animation" />
        } @else {
          <h1 class="banner-text header-text">
            {{ $contentHeader() }}
            <ng-content select="[item-selector]">
              <!-- header dropdown selector from subcomponent, use as:
          <ng-container item-selector> <content /> </ng-container> -->
            </ng-content>
          </h1>
          @if ($hasContentHeaderSecondary()) {
            <h2 class="banner-text header-secondary-text">
              {{ $contentHeaderSecondary() }}
            </h2>
          }
          @if ($hasContentHeaderTertiary()) {
            <h3 class="banner-text header-tertiary-text">
              {{ $contentHeaderTertiary() }}
            </h3>
          }
        }
      </div>
      <unity-page-return-layout>
        <ng-content select="[page-return]">
          <!-- Additional actions from subcomponent, use as:
          <ng-container page-return> <content /> </ng-container> -->
        </ng-content>
      </unity-page-return-layout>
    </div>
    <unity-page-stats-layout>
      <ng-content select="[stats]">
        <!-- Additional stats from subcomponent, use as:
          <ng-container stats> <content /> </ng-container> -->
      </ng-content>
    </unity-page-stats-layout>
    <unity-page-actions-layout>
      <ng-content select="[actions]">
        <!-- Additional actions from subcomponent, use as:
          <ng-container actions> <content /> </ng-container> -->
      </ng-content>
    </unity-page-actions-layout>
    <ng-content />
  </kendo-stacklayout>
</div>
